import React from "react"

//cutome page notification
import AllNotification from "../components/VerticalLayout/AllNotification.js"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import ManualMark from "../pages/Dashboard/ManualMark"
import Markstudent from "../pages/Dashboard/Markstudent"


//Pages
import Pages404 from "../pages/Utility/pages-404"
import Pages500 from "../pages/Utility/pages-500"
import SessionList from "pages/Session/session-list"
import SessionDetail from "pages/Session/session-detail"
import SessionNewactivity from "pages/Session/session-newactivity"

//import PlanLesson from "pages/Session/plan-lesson"
import PlanLesson from "pages/Session/plan-lesson-v2"

//Browser content
import BrowserContent from "pages/BrowserContent/browserContent"

//TimeSheet
import TimeSheet from "pages/TimeSheet/timesheet"

//student
import StudentList from "pages/StudentList/student.js"

//bmd reports
import BmdReportsListPage from "pages/BmdReports/bmd-reports-list"
import BmdReportDetailPage from "pages/BmdReports/bmd-report-detail"

import StudentReportListPage from "pages/StudentReport/student-report-list"
import StudentReportDetailPage from "pages/StudentReport/student-report-detail"


//myll
import LibraryList from "pages/MyLibrary/library-list"
import LibraryShare from "pages/MyLibrary/library-share"


//Mark Over ride functionality
import MarkAssessmentDetails from "pages/MarkOverride/mark-assessment-details.js"
import FlagAssessmentDetails from "pages/MarkOverride/flag-assessment-details.js"
import FlagDiagnosticsDetails from "pages/MarkOverride/flag-diagnostics-details.js"

//Tutor Manual functionality
import ManualAssessment from "pages/ManualMarking/manual-assessment.js"
import EngDiagMarkingPage from "pages/ManualMarking/eng-diag-marking"
import EngSkillBuilderMarkingPage from "pages/ManualMarking/eng-skillbuilder-marking"
import ManualWorksheet from "pages/ManualMarking/manual-worksheet.js"
import ManualLcmsWorksheet from "pages/ManualMarking/manual-lcms-worksheet.js"
import ManualLcmsWorksheetAnswer from "pages/ManualMarking/manual-lcms-worksheet-answer.js"

import CreateSummative from "pages/Summative/create-summative.js"

import PreviewSummativeDetails from "pages/Summative/preview-summative.js"
import { GameSummaryPage } from "../pages/Session/Games/summary/game-summary-page"

import TutorNotification from "../components/VerticalLayout/TutorNotification.js"

const VirtualSessionPage = React.lazy( () => import("../modules/online-session/virtual-session-page").then(
  module=> ({default: module.VirtualSessionPage})
))

const userRoutes = [
  { path: "/AllNotification", component: <AllNotification /> },

  { path: "/dashboard", component: <Dashboard /> },
  { path: "/activity-details/", component: <Pages404 /> },
  { path: "/activity-details/:key", component: <ManualMark /> },
  { path: "/student-details", component: <Markstudent /> },
  { path: "/TutorNotification", component: <TutorNotification /> },
  //profile
  { path: "/profile", component: <UserProfile /> },


  // this route should be at the end of all other routes
  { path: "/session", component: <SessionList /> },
  { path: "/session/:key", component: <SessionDetail /> },
  { path: "/session-newactivity", component: <SessionNewactivity /> },
  // { path: "/edit-lesson-plan", component: <SessionCreateLessonPlan /> },
  // { path: "/edit-lesson-plan/:key", component: <SessionEditLessonPlan /> },
  { path: "/edit-lesson-plan", component: <PlanLesson /> },
  { path: "/edit-lesson-plan/:key", component: <PlanLesson /> },
  { path: "/game-summary/:activity_key", component: <GameSummaryPage /> },

  { path: "/browse-content", component: <BrowserContent /> },

  //Time sheet
  { path: "/timesheet", component: <TimeSheet /> },

  //Student List
  { path: "/students", component: <StudentList /> },

  //BMD Diagnostic Reports
  { path: "/bmd-reports", component: <BmdReportsListPage /> },
  { path: "/bmd-report/", component: <Pages404 /> },
  { path: "/bmd-report/:key", component: <BmdReportDetailPage /> },

  //Student Report
  { path: "/student-report", component: <StudentReportListPage /> },
  { path: "/student-report/:key", component: <StudentReportDetailPage /> },

  { path: "/myLibrary", component: <LibraryList /> },
  { path: "/my-library-share", component: <LibraryShare /> },

  { path: "/create-summative", component: <CreateSummative /> },


  { path: "/", component: <Dashboard /> },



//mark override
  { path: "/marking-override/", component: <Pages404 /> },
  { path: "/marking-override/:key", component: <MarkAssessmentDetails /> },

  { path: "/flag-marking-override/", component: <Pages404 /> },
  { path: "/flag-marking-override/:key", component: <FlagAssessmentDetails /> },

  { path: "/flag-diagnostics-override/", component: <Pages404 /> },
  { path: "/flag-diagnostics-override/:key", component: <FlagDiagnosticsDetails /> },

//manual mark
  { path: "/manual-assessment/", component: <Pages404 /> },
  { path: "/manual-assessment/:key", component: <ManualAssessment /> },

  // The key is the pk_lesson_activity_key; the session behind it is resolved server-side.
  { path: "/eng-diag-marking/", component: <Pages404 /> },
  { path: "/eng-diag-marking/:key", component: <EngDiagMarkingPage /> },

  // Marking a Skill Builder. Its own page because it resolves a different activity type
  // and reads a different attempt table, not because the screen differs much.
  { path: "/eng-skill-builder-marking/", component: <Pages404 /> },
  { path: "/eng-skill-builder-marking/:key", component: <EngSkillBuilderMarkingPage /> },

  { path: "/manual-worksheet/", component: <Pages404 /> },
  { path: "/manual-worksheet/:key", component: <ManualWorksheet /> },

  { path: "/manual-lcms-worksheet/", component: <Pages404 /> },
  { path: "/manual-lcms-worksheet/:key", component: <ManualLcmsWorksheet /> },

  { path: "/manual-lcms-worksheet-answer/", component: <Pages404 /> },
  { path: "/manual-lcms-worksheet-answer/:key", component: <ManualLcmsWorksheetAnswer /> },

  { path: "/preview-summative-details/", component: <Pages404 /> },
  { path: "/preview-summative-details/:key", component: <PreviewSummativeDetails /> },

  { path: "/video-session/:sessionKey", component: <VirtualSessionPage />, layout: {plainLayout: true} },


];

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

];

export { userRoutes, authRoutes };
